import React, { useState, useEffect, useContext } from "react";
import { AES, enc } from "crypto-js";
import "./DailyTaskTracker.css";
import { ReactComponent as Tick } from "../../../../Assets/tick.svg";
import axios from "axios";
import { ReactComponent as Play } from "../../../../Assets/time trackingplay.svg";
import { ReactComponent as Pause } from "../../../../Assets/time trackingpause.svg";
import { ReactComponent as Stop } from "../../../../Assets/time trackingstop.svg";
import { ReactComponent as StopD } from "../../../../Assets/time trackingStopDisabled.svg";
import { ReactComponent as PlayD } from "../../../../Assets/time trackingStartDisabled.svg";
import { useNavigate } from "react-router";
import { UserContext } from "../../../../Context/Context";
import TopicSelect from "./TopicSelect";
import Select from "react-select";
import { decryptData, CustomModal, DeleteWarning } from "../../UserImport";

const learningTypeOptions = [
  "CG Learning Videos",
  "Self Learning",
  "Mentor Assigned Task",
  "Project",
  "Session",
];

const secretKey = process.env.REACT_APP_SECRET_KEY;

const MAX_COMMENT_LENGTH = 150;

const DailyTaskTracker = () => {
  const {
    isRunning,
    setIsRunning,
    isPaused,
    setIsPaused,
    elapsedTime,
    setElapsedTime,
    startTime,
    setStartTime,
    setIsStopPressed
  } = useContext(UserContext);

  const [learningType, setLearningType] = useState("");
  const [topicName, setTopicName] = useState("");
  const [comments, setComments] = useState("");
  const [comDisabled, setComDisabled] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [topicDisabled, setTopicDisabled] = useState(true);
  const [stopBtnDisabled, setStopBtnDisabled] = useState(true);
  const [resetSelect, setResetSelect] = useState(false);

  const [firstCount, setFirstCount] = useState(true);
  const [commentLength, setCommentLength] = useState(0);
  const [pauseClickCount, setPauseClickCount] = useState(0);
  const [showError, setShowError] = useState(false);
  const [showModal, setShowModal] = useState(false);


  const navigate = useNavigate();

  const customStyles = {
    container: (provided, state) => ({
      ...provided,
      width: "21.68rem",
      margin: "auto",
      marginTop: "0.37rem",
      height: "2.5rem",
    }),
    menu: (provided) => ({
      ...provided,
      width: "21.68rem",
      margin: "auto",
      maxHeight: "13rem",
      overflow: "auto"
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "lightGrey" : "white",
      color: state.isSelected ? "black" : "black",
    }),
  };

  const handleBeforeUnload = (e) => {
    if (isRunning) {
      // Cancel the event
      e.preventDefault();
      e.returnValue =
        "You have an active timer. Are you sure you want to leave this page?";
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (learningType && topicName && topicName.length <= 100) {
      setBtnDisabled(false);
    }
    else {
      setBtnDisabled(true)
    }
  }, [learningType, topicName]);

  useEffect(() => {
    if (comments.match(/^(?!.*(?:,,|\.\.|\-\-|\s{2}))[a-zA-Z0-9 ,.\-]{150,800}$/)) {
      setStopBtnDisabled(false);
    } else {
      setStopBtnDisabled(true);
    }
  }, [comments]);

  useEffect(() => {
    const encryptedData = localStorage.getItem("tD8kFi5j");
    if (encryptedData) {
      const decryptedData = AES.decrypt(encryptedData, secretKey).toString(
        enc.Utf8
      );
      if (decryptedData) {
        const {
          isRunning,
          disabled,
          comDisabled,
          learningType,
          topicName,
          comments,
          commentLength,
          startTime,
          elapsedTime,
          isPaused,
          pauseClickCount,
          firstCount,
        } = JSON.parse(decryptedData);
        setIsRunning(isRunning);
        setDisabled(disabled);
        setComDisabled(comDisabled);
        setLearningType(learningType);
        setTopicName(topicName);
        setComments(comments);
        setCommentLength(commentLength);
        setStartTime(startTime);
        setElapsedTime(elapsedTime);
        setIsPaused(isPaused);
        setPauseClickCount(pauseClickCount);
        setFirstCount(firstCount);
      }
    }
  }, []);

  useEffect(() => {
    const tD8kFi5j = JSON.stringify({
      isRunning,
      disabled,
      comDisabled,
      learningType,
      topicName,
      comments,
      commentLength,
      startTime,
      elapsedTime,
      isPaused,
      pauseClickCount,
      firstCount,
    });
    const encryptedData = AES.encrypt(tD8kFi5j, secretKey).toString();
    localStorage.setItem("tD8kFi5j", encryptedData);
  }, [isRunning, startTime, elapsedTime, isPaused, comments]);

  var parsedObject;
  const data = localStorage.getItem("userData");
  data ? parsedObject = decryptData(data, process.env.REACT_APP_USER_KEY) : navigate("/error/statusCode=400");

  const sendStartDataToBackend = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL_DOTNET + "/Dashboard/startTimer",
        {
          learningTypeId: learningTypeOptions.findIndex((option) => option == learningType) + 1,
          topicName,
          learningTypeName: learningType
        },
        {
          headers: {
            Authorization: `Bearer ${parsedObject["token"]}`,
          }
        }

      );
      localStorage.setItem("DTT-id", response.data.result.id);
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/error/statusCode=401");
      }
      if (error.response.status === 400) {
        navigate("/error/statusCode=400");
      }
      if (error.response.status === 500) {
        navigate("/error/statusCode=500");
      }
      if (error.response.status === 404) {
        navigate("/error/statusCode=404");
      }
      console.error("Error sending start data to backend:", error);
    }
  };

  const sendPauseDataToBackend = async () => {
    try {
      const dttToken = localStorage.getItem("DTT-id");
      const formData = new FormData();
      formData.append('taskId', parseInt(dttToken));

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_DOTNET}/Dashboard/pauseTimer`, formData,
        {
          headers: {
            Authorization: `Bearer ${parsedObject["token"]}`,
          },
        }
      );
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/error/statusCode=401");
      }
      if (error.response.status === 400) {
        navigate("/error/statusCode=400");
      }
      if (error.response.status === 500) {
        navigate("/error/statusCode=500");
      }
      if (error.response.status === 404) {
        navigate("/error/statusCode=404");
      }
      console.error("Error sending pause data to backend:", error);
    }
  };

  const sendStopDataToBackend = async () => {
    try {
      const token = localStorage.getItem("DTT-id");
      const response = await axios.post(
        process.env.REACT_APP_API_URL_DOTNET + "/dashboard/stopTimer",
        {
          taskId: parseInt(token),
          comment: comments,
          elapsedTime,
        },
        {
          headers: {
            Authorization: `Bearer ${parsedObject["token"]}`,
          }
        }
      );
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/error/statusCode=401");
      }
      if (error.response.status === 400) {
        navigate("/error/statusCode=400");
      }
      if (error.response.status === 500) {
        navigate("/error/statusCode=500");
      }
      if (error.response.status === 404) {
        navigate("/error/statusCode=404");
      }
      console.error("Error sending stop data to backend:", error);
    } finally {
      localStorage.removeItem("tD8kFi5j");
      localStorage.removeItem("DTT-id");
    }
  };

  const handleStop = () => {
    sendStopDataToBackend();

    setFirstCount(true);
    if (isPaused) {
      setIsPaused(false); // Resume the timer
    }
    setIsRunning(false);
    setDisabled(false);
    setCommentLength(0);
    setComDisabled(true);
    setResetSelect((val) => {
      return !val;
    });

    setElapsedTime(0);
    setBtnDisabled(true);
    setStopBtnDisabled(true);
    setComments("");
    setLearningType("");
    setTopicName("");
    setPauseClickCount(0);
  };

  const handlePause = () => {
    if (pauseClickCount < 4) {
      sendPauseDataToBackend();
      setPauseClickCount((prevCount) => prevCount + 1);
      setIsPaused(true);
    } else {
      setShowModal(true)
      // window.alert("You have exceeded the maximum pause limit!");
    }
  };

  const handleStart = () => {
    if (firstCount) {
      sendStartDataToBackend();
      setFirstCount(false);
    } else {
      sendPauseDataToBackend();
    }

    setComDisabled(false);
    setDisabled(true);

    if (isRunning) {
      setIsPaused(!isPaused);
    } else {
      if (isPaused) {
        const timerStartTime = Date.now() - elapsedTime;
        setStartTime(Date.now() - elapsedTime);
        const timerInterval = setInterval(() => {
          setElapsedTime(Date.now() - timerStartTime);
        }, 1000);

        setIsRunning(true);
        setIsPaused(false);
      } else {
        setStartTime(Date.now());
        setIsRunning(true);
        setElapsedTime(0);
      }
    }
  };

  const onLearningChange = (e) => {
    if (e == null) {
      setTopicName("");
      setTopicDisabled(true);
      return setLearningType("");
    }
    setLearningType(e.value);
    setTopicName("");
    setTopicDisabled(false);
  };

  const onTopicChange = (e) => {
    if (e == null) {
      return setTopicName("");
    } else if (
      learningType === "CG Learning Videos" ||
      learningType === "Self Learning" ||
      learningType === "Project"
    ) {
      setTopicName(e.value);
    } else {
      setTopicName(e.target.value);
    }
    if (topicName?.length <= 1) setBtnDisabled(true);
  };

  const onCommentsChange = (e) => {
    const inputComments = e.target.value;
    if (inputComments.length >= 0 && inputComments.length < 150) {
      const validComment = inputComments.match(/^(?!.*(?:,,|\.\.|\-\-|\s{2}))[a-zA-Z0-9 ,.\-]{0,150}$/);
      if (!validComment) {
        setShowError(true);
      } else {
        setShowError(false);
      }
    }
    else if (inputComments.length >= 150) {
      const validComment = inputComments.match(/^(?!.*(?:,,|\.\.|\-\-|\s{2}))[a-zA-Z0-9 ,.\-]{150,800}$/);
      if (!validComment) {
        setShowError(true);
      } else {
        setShowError(false);
      }
    }
    setCommentLength(inputComments.length);
    setComments(inputComments);
  };


  const formatTime = (timeInMs) => {
    const totalSeconds = Math.floor(timeInMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds - hours * 3600) / 60);
    const seconds = totalSeconds - hours * 3600 - minutes * 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };
  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <div className="tracker border card-body p-0">
        <div className="border-bottom ">
          <h5 className="card-title dtt-hfs ">Daily Task Tracker</h5>
        </div>
        <div>
          <label htmlFor="learning" className="form-label mt-3 dtt-lt">
            Learning Type <span style={{ color: "red" }}>* </span>
          </label>
          <Select
            styles={customStyles}
            isClearable={true}
            key={resetSelect ? "learningTypeReset" : "learningType"}
            options={learningTypeOptions.map((option) => ({
              value: option,
              label: option,
            }))}
            isDisabled={disabled}
            isSearchable={false}
            onChange={(e) => onLearningChange(e)}
            value={
              learningType ? { value: learningType, label: learningType } : null
            }

            placeholder="Select Learning Type" // Placeholder text
          />
        </div>

        <div>
          <TopicSelect
            disabled={topicDisabled || disabled}
            resetSelect={resetSelect}
            learningType={learningType}
            topicName={topicName}
            onChange={(e) => onTopicChange(e)}
          />
        </div>

        <div>
          <label htmlFor="comments" className="form-label dtt-t">
            Comments <span style={{ color: "red" }}>*</span>
          </label>
          <textarea
            placeholder="Type comments"
            id="comments"
            className="form-control dtt-text"
            value={comments}
            onChange={(e) => onCommentsChange(e)}
            disabled={comDisabled} // Add the disabled attribute
          ></textarea>
          <span
            className="charLen"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginRight: "1rem",
            }}
          >
            <span
              style={{
                color: "grey",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              {commentLength}/{MAX_COMMENT_LENGTH}
            </span>
            {
              showError && commentLength > 800 ? (
                <span style={{ color: "red" }}>Maximum length Exceeded!!</span>
              ) :
                showError && <span style={{ color: "red" }}>Invalid Comment!!</span>}
          </span>
        </div>

        <div className="d-flex align-items-center justify-content-end dtt-gap ">
          <p className="dtt-timer">{formatTime(elapsedTime)}</p>
          <div className="d-flex align-items-center justify-content-center iconGap ">
            <p>
              {isRunning && !isPaused ? (
                <Pause onClick={handlePause} disabled={pauseClickCount >= 4} />
              ) : btnDisabled ? (
                <PlayD />
              ) : (
                <Play onClick={btnDisabled ? null : handleStart} />
              )}
            </p>
            <p>
              {stopBtnDisabled ? (
                <StopD />
              ) : (
                <Stop
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal1"
                  onClick={stopBtnDisabled ? null : handleStop}
                />
              )}
            </p>
          </div>

          {/* SUCCESS MODAL */}
          <div
            className="modal fade"
            id="exampleModal1"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content sSize">
                <div className="row crossBtn">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="row tick">
                  <Tick />
                </div>
                <div className="row l1">
                  <p>Record Saved!</p>
                </div>
                <div className="row l2">
                  <p>We Have Successfully Saved Your Record.</p>
                </div>
                <div className="row continue">
                  <button
                    type="button"
                    className="continueBtn"
                    data-bs-dismiss="modal"
                    onClick={() => setIsStopPressed(true)}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <CustomModal
          modalProps={{
            icon: <DeleteWarning />,
            show: showModal,
            type: "error",
            title: "Maximum Pause Limit Exceeded",
            message: "You have exceeded the maximum pause limit!",
            onCancel: handleClose,
          }}
        />
      )}
    </>
  );
};

export default DailyTaskTracker;
